module.exports = __webpack_public_path__ + "img/add-iot-icon.1a8f2fec.svg";